import PackageList from "components/PackageList";
import { useTranslation } from "react-i18next";

export default function PackagePage() {
  const { t } = useTranslation();

  return (
    <div className={`nc-PayPage `} data-nc-id="PayPage">
      <main className="container mt-11 mb-24 lg:mb-32 ">
        <div className="space-y-6">
          <h3 className="text-2xl font-semibold">{t("packages")}</h3>
          <PackageList />
        </div>
      </main>
    </div>
  );
}
